import * as c3 from 'c3';
import * as d3 from 'd3';
import * as i0 from "@angular/core";
var ChartDefinitionService = /** @class */ (function () {
    function ChartDefinitionService() {
    }
    ChartDefinitionService.prototype.buildChart = function (selector, title, height, width) {
        var def = {
            bindto: selector,
            data: {
                columns: [
                    ['data1', 0],
                    ['data2', 0],
                    ['data3', 0],
                    ['data4', 0]
                ],
                names: {
                    data1: "Succeeded",
                    data2: "Failed",
                    data3: "In progress",
                    data4: "Other",
                },
                colors: {
                    data1: '#388e3c',
                    data2: '#d32f2f',
                    data3: '#4d8fea',
                    data4: '#e0e0e0'
                },
                type: 'donut'
            },
            tooltip: {
                format: {
                    value: d3.format(',')
                }
            },
            donut: {
                label: {
                    format: function () { return ''; }
                },
                title: title
            },
            legend: {
                position: 'right'
            },
            size: {
                height: height,
                width: width
            }
        };
        return c3.generate(def);
    };
    ChartDefinitionService.prototype.featureFlagChart = function (selector, height, width) {
        var def = {
            bindto: selector,
            data: {
                x: 'x',
                columns: [
                    ['x', '-'],
                    ['data1', '', 0],
                    ['data2', '', 0],
                    ['data3', '', 0]
                ],
                types: {
                    data1: 'bar',
                    data2: 'bar',
                    data3: 'area-step'
                },
                groups: [
                    ['data1', 'data2']
                ],
                names: {
                    data1: 'Enabled',
                    data2: 'Disabled',
                    data3: 'Old (Enabled > 21 days with no expiration date)'
                },
                order: null,
                colors: {
                    data1: '#388e3c',
                    data2: '#4d8fea',
                    data3: '#d32f2f'
                }
            },
            bar: {
                width: 30
            },
            size: {
                width: width,
                height: height
            },
            axis: {
                x: {
                    type: 'category'
                }
            }
        };
        return c3.generate(def);
    };
    ChartDefinitionService.prototype.activityChart1YWidget = function (selector, title) {
        var def = this.activityChart1YDef(selector, title, 200, 300, '#99cc00');
        def.axis.x.tick.fit = false;
        def.axis.x.tick.format = function (d) {
            var coeff = 1000 * 60 * 30;
            var date = new Date(Math.round(d.getTime() / coeff) * coeff);
            return d3.timeFormat('%H:%M')(date);
        };
        return c3.generate(def);
    };
    ChartDefinitionService.prototype.activityChart1Y = function (selector, title) {
        var def = this.activityChart1YDef(selector, title, 200, undefined, '#99cc00');
        return c3.generate(def);
    };
    ChartDefinitionService.prototype.activityChart2YWidget = function (selector, title) {
        var def = this.activityChart2YDef(selector, title, 200, 400, '');
        def.axis.x.tick.fit = false;
        def.axis.x.tick.format = function (d) {
            var coeff = 1000 * 60 * 30;
            var date = new Date(Math.round(d.getTime() / coeff) * coeff);
            return d3.timeFormat('%H:%M')(date);
        };
        return c3.generate(def);
    };
    ChartDefinitionService.prototype.activityChart2Y = function (selector, title) {
        var def = this.activityChart2YDef(selector, title, 200, undefined, '%I:%M %p');
        return c3.generate(def);
    };
    ChartDefinitionService.prototype.activityChart1YDef = function (selector, title, height, width, color) {
        var def = {
            bindto: selector,
            size: {
                height: height,
                width: width
            },
            data: {
                json: [{ occurredOn: new Date() }],
                keys: {
                    x: 'occurredOn',
                    value: ['instances'],
                },
                xFormat: '%m/%d/%Y %H:%M:%S',
                type: 'area-spline',
                axes: {
                    instances: 'y2'
                },
            },
            color: { pattern: [color] },
            grid: {
                y: { show: true }
            },
            axis: {
                y: {
                    show: false,
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: title
                },
                y2: {
                    show: true,
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: title,
                    tick: {
                        format: d3.format("d")
                    }
                },
                x: {
                    type: 'timeseries',
                    tick: {
                        fit: false,
                        format: d3.timeFormat('%I:%M %p')
                    }
                }
            },
            tooltip: {
                format: {
                    title: function (d) {
                        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
                    },
                    value: function (value) {
                        var format = d3.format(',');
                        return format(value);
                    }
                }
            }
        };
        return def;
    };
    ChartDefinitionService.prototype.activityChart2YDef = function (selector, title, height, width, xAxisFormat) {
        var def = {
            bindto: selector,
            size: {
                height: height,
                width: width
            },
            data: {
                json: [{ occurredOn: new Date() }],
                keys: {
                    x: 'occurredOn',
                    value: ['errors', 'calls'],
                },
                xFormat: '%m/%d/%Y %H:%M:%S',
                type: 'area-spline',
                axes: {
                    errors: 'y2',
                    calls: 'y'
                },
            },
            color: { pattern: ['#ff6666', '#99cc00'] },
            grid: {
                y: { show: true }
            },
            axis: {
                y: {
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: title,
                    tick: {
                        format: d3.format("d")
                    }
                },
                y2: {
                    show: true,
                    min: 0,
                    padding: { top: 5, bottom: 0 },
                    label: 'Errors',
                    tick: {
                        format: d3.format("d")
                    }
                },
                x: {
                    type: 'timeseries',
                    tick: {
                        fit: false,
                        format: function (d) {
                            return d3.timeFormat(xAxisFormat)(d);
                        }
                    }
                }
            },
            tooltip: {
                format: {
                    title: function (d) {
                        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
                    },
                    value: function (value, ratio, id) {
                        var format = d3.format(',');
                        return format(value);
                    }
                }
            }
        };
        return def;
    };
    ChartDefinitionService.ngInjectableDef = i0.defineInjectable({ factory: function ChartDefinitionService_Factory() { return new ChartDefinitionService(); }, token: ChartDefinitionService, providedIn: "root" });
    return ChartDefinitionService;
}());
export { ChartDefinitionService };
